import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import logo from '../Images/SmartLifeChoice-Logo.png';
import '../Styles/layout.css';
import '../Styles/utils.css';
import '../Styles/reset.css';

function Header() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
    const [isMobileCategoriesOpen, setIsMobileCategoriesOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        setIsMobileCategoriesOpen(false);
    };

    const toggleMobileCategories = () => {
        setIsMobileCategoriesOpen(!isMobileCategoriesOpen);
    };

    return (
        <header className="header">
            <div className="container header-container">
                <Link to="/" className="logo">
                    <img src={logo} alt="SmartLifeChoice" className="logo-image" />
                    <span className="logo-text">SmartLifeChoice</span>
                </Link>

                <nav className="nav">
                    <Link to="/" className="nav-link">Home</Link>
                    <div
                        className="nav-dropdown"
                        onMouseEnter={() => setIsCategoriesOpen(true)}
                        onMouseLeave={() => setIsCategoriesOpen(false)}
                    >
                        <button className="nav-link dropdown-trigger">
                            Categories <ChevronDown size={16} />
                        </button>
                        <div className={`dropdown-menu ${isCategoriesOpen ? 'active' : ''}`}>
                            <Link to="/category/nutrition" className="dropdown-link">Nutrition</Link>
                            <Link to="/category/workouts" className="dropdown-link">Workouts</Link>
                            <Link to="/category/mental-health" className="dropdown-link">Mental Health</Link>
                            <Link to="/category/wellness" className="dropdown-link">Wellness</Link>
                        </div>
                    </div>
                    <Link to="/about" className="nav-link">About</Link>
                    <Link to="/contact" className="nav-link">Contact</Link>
                </nav>

                <button className="mobile-nav-toggle" onClick={toggleMobileMenu}>
                    <Menu size={24} />
                </button>
            </div>

            <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
                <button className="mobile-nav-close" onClick={toggleMobileMenu}>
                    <X size={24} />
                </button>

                <div className="mobile-nav-links">
                    <Link to="/" className="mobile-nav-link" onClick={toggleMobileMenu}>Home</Link>
                    <div className="mobile-dropdown">
                        <button
                            className="mobile-nav-link mobile-dropdown-trigger"
                            onClick={toggleMobileCategories}
                        >
                            Categories <ChevronDown size={16} className={isMobileCategoriesOpen ? 'rotate' : ''} />
                        </button>
                        <div className={`mobile-dropdown-menu ${isMobileCategoriesOpen ? 'active' : ''}`}>
                            <Link to="/category/nutrition" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Nutrition</Link>
                            <Link to="/category/workouts" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Workouts</Link>
                            <Link to="/category/mental-health" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Mental Health</Link>
                            <Link to="/category/wellness" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Wellness</Link>
                        </div>
                    </div>
                    <Link to="/about" className="mobile-nav-link" onClick={toggleMobileMenu}>About</Link>
                    <Link to="/contact" className="mobile-nav-link" onClick={toggleMobileMenu}>Contact</Link>
                </div>
            </div>
        </header>
    );
}

export default Header;
